import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, IdpAuthenticatorsService) {
        this.$state = $state;
        this.Alert = Alert;
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
    }

    $onInit() {
        if(this.idpAuthenticator == null) {
            this.$state.go('company.idp-authenticators.list');
            return;
        }
        this.st = new SmartTable();
        this.samlAppLogo = window.env.urls.samlAppLogo;
    }

    assign() {
        this.isSaving = true;
        this.IdpAuthenticatorsService
            .assignApplications(this.companyId, this.idpAuthenticator.id, this.st.selectedIds)
            .then(() => this.$state.go('^', {}, {reload: 'company.idp-authenticators'}))
            .then(() => this.Alert('success', 'company.idp-authenticators.manage.applications.updated'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/applications/assign/idp-authenticator-applications-assign.controller.js